<template>
  <div class="downLoad">
    <!-- 标题 -->
    <div v-if="num==0">
      <div class="downLoadTitle clearFloat">
        <i class="downLoadTitlePic"></i>
        <h3 class="downLoadTitleText">通知公告</h3>
        <div style="width: 50%;display: inline-block;margin-left: 10%;position: relative;">
          <el-input
            placeholder="请输入内容"
            v-model="value"
            clearable
            @blur="search"
            @keyup.enter="search"
          ></el-input>
          <el-image src="static/image/sousuo.png" class="search" @click="search"></el-image>
        </div>
      </div>
      <!-- 列表 -->
      <div class="content-center-row" style="margin-top:1.5%">
        <div v-for="(item,i) in listData" :key="i">
          <el-row :gutter="20" style="margin-top: 0%;">
            <!-- <el-col :span="4" style="height:100%">
              <el-image
                v-if="item.img_url!=''&&item.img_url!=null"
                class="recommend-img top-image"
                style="height:100%"
                :src="item.img_url"
              ></el-image>
              <el-image
                v-else
                class="recommend-img top-image"
                style="height:100%"
                src="static/image/error.png"
              ></el-image>
            </el-col> -->
            <el-col :span="20">
              <div class="between">
                <div class="font-14" style="font-size: 16px;font-weight: bold;" @click="detail(item)">{{item.title}}</div>
                <div class="font-14" style="margin-top:2px;margin-right:18px;">{{item.created_t}}</div>
              </div>
              <!-- <div
                class="outer left-menu font-13"
                style="text-indent:1.5em;margin: 5px 0%;height:30px;overflow:hidden;color:#8c8585"
                v-html="item.content"
              ></div> -->
              <div class="right-menu pointer font-12" style="color:#EA5413;margin-top:20px;" @click="detail(item)">
                <span style="padding-right:20px;color:#000">
                  <span style="margin-right:5px">浏览次数</span>
                  <span style="color:#569CD6">{{item.qty}}</span>
                </span>
                阅读全文>>
              </div>
            </el-col>
          </el-row>
<!--          <br />-->
          <hr style="color:rgba(0,0,0,1)" />
        </div>
        <el-pagination
          style="margin-top:4%"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["faNum", "click_detail"],
  components: {},
  data() {
    return {
      value: "",
      listData: [], //获取的数据
      // 分页
      page: 1,
      total: 0,
      pageSize: 10,
      componented: "",
      num: this.faNum
    };
  },

  mounted() {
    this.view();
  },

  methods: {
    // 获取数据
    view(keyword) {
      this.$axios({
        method: "post",
        url: "index/notice/search",
        params: {
          page: this.page,
          pagesize: this.pageSize,
          keyword: keyword
        }
      }).then(res => {
        this.listData = res.data.data.data.data;
        this.total = res.data.data.data.total;
      });
    },
    detail(item) {
      this.$axios({
        method: "post",
        url: "index/notice/inc_qty",
        params: {
          type: "notice",
          id: item.id
        }
      }).then(res => {});
      this.click_detail("notice_detail", item);
    },
    // 搜索
    search() {
      this.view(this.value);
    },
    // 每页显示数量
    handleSizeChange(item) {
      this.pageSize = item;
      this.view();
    },
    // 页数改变
    handleCurrentChange(pages) {
      this.page = pages;
      this.view();
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style: none;
}
.downLoad {
  width: 100%;
  // 标题
  .downLoadTitle {
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
    .downLoadTitlePic {
      float: left;
      width: 8px;
      height: 21px;
      background: url("/static/image/strip.png") no-repeat;
      margin-right: 1%;
      margin-top: 6px;
    }
    .downLoadTitleText {
      float: left;
      line-height: 0;
      color: #c39a58;
    }
    .select {
      float: left;
      background-color: #ffffff;
      margin-left: 10%;
      margin: 0.5% 0 0 10%;
      /deep/.el-input {
        width: 95%;
      }
      .selectIcon {
        float: right;
        width: 20px;
        height: 20px;
        width: 5%;
        background: url("/static/image/sousuo.png") no-repeat;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
  // 列表
  .downContent {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    .title {
      font-size: 19px;
      padding: 5% 0;
      background-color: red;
    }
    .downloadList {
      border-bottom: 1px solid #eeeeee;
      // padding-bottom: 5px;
      padding: 5px 0;
      .downLoadTitle {
        float: left;
        width: 39%;
        border: 0;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 1%;
        padding: 0 1%;
        box-sizing: border-box;
        font-size: 12px;
      }
      .downLoadNum,
      .updataTime {
        width: 15%;
        margin-left: 1%;
        float: left;
        margin-top: 1%;
        font-size: 12px;
      }
      .updataTime {
        width: 30%;
      }
      .downLoadText {
        font-size: 12px;
        margin-left: 3%;
      }
      .downLoadBtn {
        float: right;
        background-color: #c39a58;
        color: #ffffff;
        border: none;
      }
    }
  }
  .a {
    width: 100px;
    height: 100px;
    background-color: purple;
    clear: both;
  }
}
.outer {
  overflow: hidden;
  text-overflow: ellipsis;
  /*设置成弹性盒子 */
  display: -webkit-box;
  /*显示的个数 */
  -webkit-line-clamp: 2;
  /* 属性规定框的子元素应该被水平或垂直排列。 */
  -webkit-box-orient: vertical;
}
.search {
  position: absolute;
  z-index: 9;
  top: 10px;
  right: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/Customized/components/notice/index.vue